import { __spreadArray } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TextField, Box, IconButton, Button, } from "@mui/material";
import FileUploadOutlined from "@mui/icons-material/FileUploadOutlined";
import { CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { useRef, useState, useEffect } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
var TripDetailsForm = function (_a) {
    var _b;
    var data = _a.data, updateData = _a.updateData, onNext = _a.onNext, validationErrors = _a.validationErrors;
    var _c = useState(0), fileInputKey = _c[0], setFileInputKey = _c[1];
    var _d = useState(null), localPreviewUrl = _d[0], setLocalPreviewUrl = _d[1];
    var fileInputRef = useRef(null);
    // Set preview URL from persisted data
    useEffect(function () {
        if (data.coverImage && typeof data.coverImage === "string") {
            setLocalPreviewUrl(data.coverImage);
        }
    }, [data.coverImage]);
    var handleFileChange = function (event) {
        var _a;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file) {
            updateData({ coverImageFile: null, coverImage: null });
            setLocalPreviewUrl(null);
            return;
        }
        updateData({ coverImageFile: file });
        // Convert file to data URL for persistence
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            var dataUrl = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
            updateData({ coverImage: dataUrl });
            setLocalPreviewUrl(dataUrl);
        };
        reader.readAsDataURL(file);
    };
    var handleBannerUploadClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var addHighlight = function () {
        updateData({ highlights: __spreadArray(__spreadArray([], data.highlights, true), [""], false) });
    };
    var removeHighlight = function (idx) {
        var newHighlights = __spreadArray([], data.highlights, true).filter(function (item, index) { return index !== idx; });
        updateData({ highlights: newHighlights });
    };
    var updateHighlight = function (idx, value) {
        var newHighlights = __spreadArray([], data.highlights, true).map(function (item, index) {
            if (index === idx) {
                return value;
            }
            return item;
        });
        updateData({ highlights: newHighlights });
    };
    var addInclusion = function () {
        updateData({ inclusions: __spreadArray(__spreadArray([], data.inclusions, true), [""], false) });
    };
    var removeInclusion = function (idx) {
        var newInclusions = __spreadArray([], data.inclusions, true).filter(function (item, index) { return index !== idx; });
        updateData({ inclusions: newInclusions });
    };
    var updateInclusion = function (idx, value) {
        var newInclusions = __spreadArray([], data.inclusions, true).map(function (item, index) {
            if (index === idx) {
                return value;
            }
            return item;
        });
        updateData({ inclusions: newInclusions });
    };
    var addExclusion = function () {
        updateData({ exclusions: __spreadArray(__spreadArray([], data.exclusions, true), [""], false) });
    };
    var removeExclusion = function (idx) {
        var newExclusions = __spreadArray([], data.exclusions, true).filter(function (item, index) { return index !== idx; });
        updateData({ exclusions: newExclusions });
    };
    var updateExclusion = function (idx, value) {
        var newExclusions = __spreadArray([], data.exclusions, true).map(function (item, index) {
            if (index === idx) {
                return value;
            }
            return item;
        });
        updateData({ exclusions: newExclusions });
    };
    var transportModes = [
        "Flight",
        "Train",
        "Bus",
        "Car",
        "Cruise",
        "Bike",
        "On Foot",
    ];
    return (_jsxs(WrapperContainer, { "$flexDirection": "column", children: [_jsxs(Box, { sx: {
                    padding: "24px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "24px",
                    backgroundColor: "#fff",
                }, children: [_jsx(CustomText, { "$fontSize": "20px", "$fontWeight": "700", "$margin": "0 0 8px 0", children: "Cover Image" }), _jsx(CustomText, { "$fontSize": "14px", "$color": "#5f6368", "$margin": "0 0 16px 0", children: "This will be the main image for your trip page." }), _jsx(Box, { sx: {
                            border: "2px dashed #dadce0",
                            borderRadius: "16px",
                            padding: "40px",
                            textAlign: "center",
                            backgroundColor: "#fff",
                            cursor: "pointer",
                        }, onClick: handleBannerUploadClick, children: localPreviewUrl ? (_jsx("img", { src: localPreviewUrl, alt: "Cover Preview", style: {
                                maxWidth: "100%",
                                maxHeight: "200px",
                                borderRadius: "8px",
                            } })) : (_jsxs(_Fragment, { children: [_jsx(FileUploadOutlined, { sx: { fontSize: 40, color: "#5f6368", mb: 2 } }), _jsx(CustomText, { "$fontSize": "14px", "$fontWeight": "600", "$justifyContent": "center", children: "Upload a file or drag and drop" }), _jsx(CustomText, { "$fontSize": "12px", "$color": "#5f6368", "$justifyContent": "center", children: "PNG, JPG up to 10MB" })] })) }), _jsx("input", { type: "file", ref: fileInputRef, onChange: handleFileChange, accept: "image/*", style: { display: "none" } }, fileInputKey), ((validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.coverImage) || (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.coverImageFile)) && (_jsx(CustomText, { "$fontSize": "12px", "$color": "#d93025", "$margin": "8px 0 0 0", children: validationErrors.coverImage || validationErrors.coverImageFile }))] }), _jsxs(Box, { sx: {
                    padding: "24px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "24px",
                    backgroundColor: "#fff",
                }, children: [_jsx(CustomText, { "$fontSize": "20px", "$fontWeight": "700", "$margin": "0 0 8px 0", children: "Description" }), _jsx(TextField, { fullWidth: true, multiline: true, rows: 6, placeholder: "Provide a brief summary of the trip's purpose...", helperText: (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.description) || "Basic formatting is supported.", error: Boolean(validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.description), value: data.description, onChange: function (e) { return updateData({ description: e.target.value }); } })] }), _jsxs(Box, { sx: {
                    padding: "24px",
                    border: "1px solid #e0e0e0",
                    borderRadius: "24px",
                    backgroundColor: "#fff",
                }, children: [_jsx(CustomText, { "$fontSize": "20px", "$fontWeight": "700", "$margin": "0 0 8px 0", children: "Trip Highlights" }), _jsxs(Box, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                            marginTop: "1rem",
                            borderRadius: "0.5rem",
                        }, children: [((_b = data.highlights) !== null && _b !== void 0 ? _b : []).map(function (highlight, idx) { return (_jsxs(Box, { sx: {
                                    //p: 2,
                                    mb: 1,
                                    //border: "1px solid #f1f3f4",
                                    //borderRadius: "12px",
                                    //bgcolor: "#f8f9fa",
                                    position: "relative",
                                }, children: [_jsx(TextField, { fullWidth: true, label: "Highlight ".concat(idx + 1), size: "small", value: highlight !== null && highlight !== void 0 ? highlight : "", onChange: function (e) { return updateHighlight(idx, e.target.value); } }), _jsx(IconButton, { sx: {
                                            position: "absolute",
                                            top: 8,
                                            right: 8,
                                            color: "#d93025",
                                        }, onClick: function () { return removeHighlight(idx); }, children: _jsx(DeleteOutlineIcon, { fontSize: "small" }) })] }, idx)); }), (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.highlights) && (_jsx(CustomText, { "$fontSize": "12px", "$color": "#d93025", "$margin": "8px 0 0 0", children: validationErrors.highlights })), _jsx(Button, { startIcon: _jsx(AddCircleOutlineIcon, {}), sx: { textTransform: "none", fontWeight: 600 }, onClick: function () { return addHighlight(); }, children: "Add Highlight" })] })] })] }));
};
export default TripDetailsForm;
